import type { Enums } from "../types";

export function getTransactionTypeColor(type: Enums<"transactionType">): Enums<"color"> {
	switch (type) {
		case "correction":
			return "amber";
		case "pick":
			return "emerald";
		case "inventory":
			return "blue";
		case "restock":
			return "violet";
		case "return":
			return "slate";
	}
}
